if (
  typeof String !== undefined
  && String.prototype
  && !String.prototype.toSeconds
) {
  Object.defineProperty(String.prototype, 'toSeconds', {
    value() {
      let [stamp, ms] = this.split('.');
      const p = stamp.split(':');
      let s = 0;
      let m = 1;
      if (!ms || !ms.length) ms = 0;
      while (p.length > 0) {
        s += m * parseInt(p.pop() || 0, 10);
        m *= 60;
      }
      return s + parseFloat(`.${ms}`);
    }
  });
}